import styled from 'styled-components';

export const Details = styled.section<{$hideContent: boolean, $expand: boolean}>`
    position: relative;
    display: ${({ $hideContent }) => $hideContent ? 'none' : 'flex'};
    width: 100%;
    max-width: ${({ $expand }) => $expand ? '787px' : '100%'};
    align-items: flex-start;
    gap: 24px;
    padding: 16px;
    
    @media (max-width: 1200px) {
        padding-top: 0;
    }
`;

export const CardImage = styled.aside`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: auto;
`;

export const DetailsEvent = styled.aside<{$expand: boolean}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    max-width: ${({ $expand }) => $expand ? '787px' : '100%'};
    gap: 8.5px;
    margin-left: ${({ $expand }) => $expand ? '24px' : '0px'};

    @media (max-width: 1200px) {
        margin-left: 0;
        padding-top: 16px;
    }
`;

export const ImageEvent = styled.img`
    width: 76px;
    height: 76px;
    border-radius: 8px;
    box-sizing: border-box;
    object-fit: cover;
`;

export const Title = styled.h1`
    margin: 0;
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: left;
`;

export const Subtitle = styled.h2`
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;
`;

export const Info = styled.section`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
`;

export const Icon = styled.img``;

export const RowFullWidth = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: -2.5px;
    gap: 8px;

    @media (max-width: 1200px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 16px;
    }
`;

export const TextLink = styled.span`
  background-color: transparent;
  padding: 0;
  margin: 0;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: center;
  color: ${({ theme : { colors } }) => colors.accent.primary};
  
  &:hover {
    background-color: transparent;
    cursor: pointer;
  }
`;

export const Wrapper = styled.section`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
`;

export const TextPillButton = styled.span`
    padding: 6px 12px;
    height: 24px;
    width: auto;
    border-radius: 50px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    background-color: ${({ theme }) => theme.colors.pillbutton.surface};
    
    font-family: Inter;
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.pillbutton.text};
`;
